import { render, staticRenderFns } from "./ClientElo.vue?vue&type=template&id=5c8a2904&scoped=true&"
import script from "./ClientElo.vue?vue&type=script&lang=js&"
export * from "./ClientElo.vue?vue&type=script&lang=js&"
import style0 from "./ClientElo.vue?vue&type=style&index=0&id=5c8a2904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a2904",
  null
  
)

export default component.exports